import React from "react";


const Coming_Soon = () => {
    return(
        <h1>Coming_Soon</h1>
    )
}

export default Coming_Soon